// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"53":"2cd2f084c1755ea8","436":"e67fd1f07e6bd970","489":"ee886e24947c2482"}[chunkId] + ".js";
};